import { AxiosError } from 'axios';
import { QueryConfig, useQuery } from 'react-query';

import { TenderCoreRegVM } from '~src/types/db';
import { QueryKeys } from './queryKeys';
import {
  LoadTendersParams,
  loadTendersRegistrationCoreTenders,
} from '~src/services/api';

export const useRegistrationCoreTenders = (
  params: LoadTendersParams,
  queryConfig: QueryConfig<TenderCoreRegVM, AxiosError> = {}
) => {
  const { enabled, ...options } = queryConfig;

  const enabledOverride = enabled || enabled === undefined;

  const filesQuery = useQuery(
    [QueryKeys.coreTenderRegistration, params],
    loadTendersRegistrationCoreTenders,
    {
      enabled: enabledOverride && params.projectId && params.tenderId,
      ...options,
    }
  );

  return filesQuery;
};
